<script>
import AppInputDouble from '@/components(new)/UI/Forms/InputDouble/InputDouble.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import Card from '@/components(new)/UI/Cards/Card/Card.vue'

import * as slct from '@/libs/constants/praticas/opcoesSelects'
import { formataStringYearMonthToBr } from '@/utils/utils'

export default {
  components: {
    TitleWithRow,
    Label,
    InputSelect,
    AppInputDouble,
    Card
  },
  data () {
    return {
      nomeAba: 'Práticas',
      slct,
      criacoes: {
        dataInicio: '',
        numeroAnimais: '',
        tipoCriacao: '',
        outrasCriacoes: ''
      }
    }
  },
  props: {
    pratica: {
      required: true
    }
  },
  computed: {
    disableButton () {
      return !(
        this.criacoes.dataInicio &&
        this.criacoes.numeroAnimais &&
        this.criacoes.tipoCriacao &&
        ((this.containsOption(this.criacoes.tipoCriacao, 'OUTROS', 'criacoes.outrasCriacoes', true) && this.criacoes.outrasCriacoes) || !this.containsOption(this.criacoes.tipoCriacao, 'OUTROS', 'criacoes.outrasCriacoes', true))
      )
    }
  },
  methods: {
    formataStringYearMonthToBr,
    containsOption (parent, option, model, isCard = false) {
      let contains

      if (!Array.isArray(parent)) {
        contains = parent === option
      } else {
        contains = parent.includes(option)
      }

      if (!contains) {
        const props = model.split('.')
        const lastProp = props.pop()
        const target = props.reduce((acc, curr) => acc?.[curr], this.pratica)
        if (target && lastProp) {
          target[lastProp] = null
          if (isCard) {
            this.criacoes[lastProp] = null
          }
        }
      }
      return contains
    },
    parseNumber (value) {
      return parseInt(value.replace(/[^0-9]/g, ''))
    },
    btnAdicionar () {
      this.pratica.criacoes.push({
        ...this.criacoes
      })
      this.criacoes = {
        dataInicio: '',
        numeroAnimais: '',
        tipoCriacao: '',
        outrasCriacoes: ''
      }
    },
    btnApagar (index) {
      this.pratica.criacoes.splice(index, 1)
    },
    btnEditar (criacao, index) {
      this.criacoes = {
        dataInicio: criacao.dataInicio,
        numeroAnimais: criacao.numeroAnimais,
        tipoCriacao: criacao.tipoCriacao,
        outrasCriacoes: criacao.outrasCriacoes
      }
      this.btnApagar(index)
    }
  }
}
</script>
<template>
  <div>
    <TitleWithRow title="Criação" />
    <el-row :gutter="20">
      <InputSelect
        label="Tipo de criação"
        v-model="criacoes.tipoCriacao"
        :nomeAba="nomeAba"
        :obrigatorio="true"
        :rulesInput="!pratica.criacoes.length ? 'required' : ''"
        :opcoes="slct.opcoesTipoCriacao"
        :widthColumn="containsOption(criacoes.tipoCriacao, 'OUTROS', 'criacoes.outrasCriacoes', true) ? 6 : 8"
      />
      <el-col :span="6" v-if="containsOption(criacoes.tipoCriacao, 'OUTROS', 'criacoes.outrasCriacoes', true)">
        <validation-provider
          :rules="!pratica.criacoes.length ? 'required' : ''"
          v-slot="{ errors }"
          mode="lazy"
          :name="`${nomeAba}/Outros`"
        >
          <Label
            label="Outros"
            :obrigatorio="!pratica.criacoes.length"
          />
          <el-input
            name="Outros"
            v-model="criacoes.outrasCriacoes"
            clearable
            :class="{'input erro' : errors.length}"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </validation-provider>
      </el-col>
      <el-col :span="containsOption(criacoes.tipoCriacao, 'OUTROS', 'criacoes.outrasCriacoes', true) ? 6 : 8">
        <validation-provider
          :rules="!pratica.criacoes.length ? 'required' : ''"
          v-slot="{ errors }"
          mode="lazy"
          :name="`${nomeAba}/Número de animais`"
        >
          <Label
            label="Número de animais"
            :obrigatorio="!pratica.criacoes.length"
          />
          <el-input
            name="Número de animais"
            v-model="criacoes.numeroAnimais"
            clearable
            :class="{'input erro' : errors.length}"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </validation-provider>
      </el-col>
      <el-col :span="containsOption(criacoes.tipoCriacao, 'OUTROS', 'outrasCriacoes', true) ? 6 : 8">
        <validation-provider
          :rules="!pratica.criacoes.length ? 'required' : ''"
          v-slot="{ errors }"
          mode="lazy"
          :name="`${nomeAba}/Data de início`"
        >
          <Label
            label="Data de início"
            :obrigatorio="!pratica.criacoes.length"
          />
          <el-date-picker
            name="Data de início"
            v-model="criacoes.dataInicio"
            :class="{'input erro' : errors.length}"
            type="month"
            placeholder="Selecione mês e ano"
            format="MM/yyyy"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </validation-provider>
      </el-col>
    </el-row>
    <el-row style="width: 100%; top: 20px; display: flex; justify-content: flex-end;">
      <el-button
        :disabled="disableButton"
        round type="primary"
        @click="btnAdicionar()"
      >
        Adicionar
      </el-button>
    </el-row>
    <div style="display: flex; flex-wrap: wrap;">
      <div v-for="(c, i) in pratica.criacoes" :key="i+c.tipoCriacao">
        <Card
          :objeto="{
            ...c,
            dataInicio: formataStringYearMonthToBr(c.dataInicio),
            tipoCriacao: pratica.criacoes ? slct.opcoesTipoCriacao.find(criacao => criacao.id === c.tipoCriacao).nome : '-'
          }"
          :deletar="() => btnApagar(i)"
          :editar="() => btnEditar(c, i)"
          titulo="Tipo de criação"
        />
      </div>
    </div>
    <TitleWithRow title="Manejo" />
    <el-row :gutter="20">
      <InputSelect
        label="Tipo de manejo predominante"
        v-model="pratica.tiposManejo"
        :nomeAba="nomeAba"
        obrigatorio
        rulesInput="required"
        :opcoes="slct.opcoesTipoManejo"
        :widthColumn="12"
        multiSelect
      />
    </el-row>
    <TitleWithRow title="Tratamento de resíduos" />
    <el-row :gutter="20">
      <InputSelect
        label="Tipo de tratamento"
        v-model="pratica.tiposTratamento"
        :nomeAba="nomeAba"
        obrigatorio
        rulesInput="required"
        :opcoes="slct.opcoesTipoTratamento"
        :widthColumn="12"
        multiSelect
      />
      <validation-provider
        rules="required"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Outros tipos de tratamento`"
        v-if="containsOption(pratica.tiposTratamento, 'OUTROS', 'outrosTiposTratamento')"
      >
        <el-col :span="12">
          <Label
            label="Quais?"
            obrigatorio
          />
          <el-input
            name="Outros tipos de tratamento"
            v-model="pratica.outrosTiposTratamento"
            :class="{'input erro' : errors.length}"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>
    <el-row :gutter="20">
      <InputSelect
        label="Aproveitamento do resíduo tratado"
        v-model="pratica.tiposAproveitamentoResiduos"
        :nomeAba="nomeAba"
        obrigatorio
        rulesInput="required"
        :opcoes="slct.opcoesAproveitamentoResiduos"
        :widthColumn="12"
        multiSelect
      />
      <validation-provider
        rules="required"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Outros tipos de aproveitamento de resíduos`"
        v-if="containsOption(pratica.tiposAproveitamentoResiduos, 'OUTROS', 'outrosTiposAproveitamentoResiduos')"
      >
        <el-col :span="12">
          <Label
            label="Quais?"
            obrigatorio
          />
          <el-input
            name="Outros tipos de aproveitamento de resíduos"
            v-model="pratica.outrosTiposAproveitamentoResiduos"
            :class="{'input erro' : errors.length}"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>

    <TitleWithRow title="Financiamento" />
    <el-row :gutter="20">
      <InputSelect
        label="Fonte de financiamento para implementação da prática"
        v-model="pratica.financiamentos"
        :nomeAba="nomeAba"
        obrigatorio
        rulesInput="required"
        :opcoes="slct.opcoesFonteFinanciamento"
        :widthColumn="12"
        multiSelect
      />
      <validation-provider
        rules="required"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Outros tipos de fonte de financiamento`"
        v-if="containsOption(pratica.financiamentos, 'OUTRO', 'outroFinanciamento')"
      >
        <el-col :span="12">
          <Label
            label="Quais?"
            obrigatorio
          />
          <el-input
            name="Outros tipos de fonte de financiamento"
            v-model="pratica.outroFinanciamento"
            :class="{'input erro' : errors.length}"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>
    <TitleWithRow title="" />
    <el-row :gutter="20">
      <validation-provider
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Descrição`"
      >
      <el-col :span="24">
        <Label
          label="Descrição"
        />
        <el-input
          name="Descrição"
          v-model="pratica.descricao"
          :class="{'input erro' : errors.length}"
          type="textarea"
          maxlength="500"
          show-word-limit
        />
        <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
      </el-col>
      </validation-provider>
    </el-row>
  </div>
</template>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/MRPA/MRPA.vue